import React, { useContext } from 'react';
import Spa from "@components/spas/Spa";
import ReactDOM from "react-dom/client";

import { ImageAnnotationComponent } from './form-sketch/ImageAnnotationComponent';
import { FormSketchComponent } from './form-sketch/FormSketchComponent';
import { isInIframe } from '@helpers/util';
import { CompanyProfileContext } from '@components/providers/CompanyProfileProvider';
import GreenButton from '@components/ui/buttons/GreenButton';

let formSketchIFrame = null;
let iframe_RootElement = null;

const mount_iFrame = () => {
    formSketchIFrame = document.createElement("iframe");

    //get the current URL params query string.
    formSketchIFrame.src = `about:blank`;
    formSketchIFrame.style.display = "none";
    formSketchIFrame.style.position = "fixed";
    formSketchIFrame.style.top = "0";
    formSketchIFrame.style.left = "0";
    formSketchIFrame.style.width = "100%";
    formSketchIFrame.setAttribute("scrolling", "no");
    formSketchIFrame.setAttribute("frameborder", "0");
    formSketchIFrame.style.height = "100%";
    formSketchIFrame.style.zIndex = "999999999";
    formSketchIFrame.style.overflow = "hidden";
    formSketchIFrame.id = "form-sketch-iframe";
    window.document.body.appendChild(formSketchIFrame);
}

const load_formSketch = ({
    onLoad
}) => {
    const frame = find_iFrame();
    if(frame) {
        if(
            frame.contentWindow?.document.getElementById("form-sketch-mount") != null
        ) {
            onLoad();
            return;
        }

        if (formSketchIFrame) {
            formSketchIFrame.style.display = "block";
        }

        //inject loader.
        const loaderDiv = frame.ownerDocument.createElement("div");
        loaderDiv.style.position = "fixed";
        loaderDiv.style.display = "flex";
        loaderDiv.style.justifyContent = "center";
        loaderDiv.style.alignItems = "center";
        loaderDiv.style.height = "100vh";
        loaderDiv.style.width = "100vw";
        loaderDiv.style.top = 0;
        loaderDiv.style.left = 0;
        loaderDiv.style.zIndex = 999999999;
        loaderDiv.innerText = "Loading...";

        frame.ownerDocument.body.appendChild(loaderDiv);
        const urlParams = new URLSearchParams(window.location.search);
        frame.src = `${process.env.FORMITIZE_ROOT}formsketch/?` + urlParams.toString();
        frame.onload = () => {
            frame.ownerDocument.body.removeChild(loaderDiv);
            onLoad();
        };

        frame.onerror = () => {
            frame.ownerDocument.body.removeChild(loaderDiv);
            alert("Failed to load form sketch");
        }       
    }
}

const exit_iFrame = (source) => {
    const frame = find_iFrame();

    if(iframe_RootElement) {
        iframe_RootElement.unmount();
        iframe_RootElement = null;
    }
    frame.style.display = "none";
    source.document.body.style.overflow = "";

}

const render_iFrame = (Component, props) => {
    const element = document.getElementById("form-sketch-mount");

    if(iframe_RootElement != null) {
        iframe_RootElement.unmount();
        iframe_RootElement = null;
    }

    iframe_RootElement = ReactDOM.createRoot(element);
    iframe_RootElement.render(React.createElement(Component, props));
}

//Traverse our way up to find the iFrame.
//We don't want to use window.top just in case webforms are being used in an iFrame.
const find_iFrame = () => {
    let w = window;
    while(w) {
        let dom = w.document.getElementById("form-sketch-iframe");
        if(dom) return dom;

        if(w === w.parent) break;
        w = w.parent;
    }

    return null;

}

const initiateAnnotationIFrame = ({
    formIndex,
    objectId,
    repeatedIndex,
    imageSrc,
    meta = {},
    dataset = {}
}, source) => {
    const frame = find_iFrame();

    if (!frame) {
        console.warn("formSketchIFrame not found");
        return;
    }

    frame.style.display = "block";
    frame.contentWindow.document.body.style.overflow = "hidden";

    const onSave = (payload) => {
        source.postMessage({
            type: 'form-sketch-annotate',
            event: 'save',
            data: payload
        }, "*");
    };

    const onExit = () => {
        exit_iFrame(source);
    };

    render_iFrame(
        ImageAnnotationComponent,
        {
            onSave,
            onExit,
            formIndex: formIndex,
            objectId: objectId,
            repeatedIndex: repeatedIndex,
            imageSrc: imageSrc,
            dataset: dataset
        }
    );
};


const initiateAnnotation = (props) => {
    const frame = find_iFrame();
    frame.style.display = "block";
    document.body.style.overflow = "hidden";
    

    load_formSketch({
        onLoad: () => {
            frame.contentWindow.postMessage({
                type: 'form-sketch',
                event: 'init-annotation-iframe',
                data: props
            }, "*");
        }
    });
}

const initiateFormSketchIFrame = ({
    repeatedIndex, objectId, formIndex, formSketchData, formSketchSettings
}, source) => {
    const ComponentWrapper = (props) => {
        const formSketchOnSave = async (data) => {
            source.postMessage({
                type: 'form-sketch-data',
                event: 'save',
                data: data
            }, "*");
        }

        const formSketchOnExit = async () => {
            exit_iFrame(source);
        };

        return <FormSketchComponent {...props} onSave={formSketchOnSave} onExit={formSketchOnExit} />
    }


    render_iFrame(
        ComponentWrapper,
        {
            repeatedIndex,
            objectId,
            formIndex,
            formSketchData,
            formSketchSettings
        }
    );

}

const initiateFormSketch = () => {
    document.querySelectorAll(".formCanvas-form-sketch").forEach((domContainer) => {
        domContainer.classList.remove("formCanvas-form-sketch");
        const root = ReactDOM.createRoot(domContainer);

        const parent = domContainer.parentElement;

        const repeatedIndex = parent.getAttribute("repeatedcount");
        const objectId = parent.getAttribute("form-id");
        const formIndex = parent.getAttribute("index");
        const companyDataString = parent.getAttribute("data-company-data") ?? 'e30=' ;
        const companyData = btoa(decodeURIComponent(atob(companyDataString)));

        const Button = ({
            repeatedIndex,
            objectId,
            formIndex
        }) => {

            const profile = useContext(CompanyProfileContext);

            const onClick = () => {
                const frame = find_iFrame();

                formitize.api.form.objects.formCanvas.getFormSketchData(formIndex, objectId, repeatedIndex).then(
                    (response) => {
                        let formSketchData = null;
                        (async () => {
                            try {
                                formSketchData = response.jsonPayload;
                            } catch(ex) {
                                //swallow.
                            }
                        })().finally( () => {

                            frame.style.display = "block";
                            document.body.style.overflow = "hidden";

                            load_formSketch({
                                onLoad: () => {
                                    frame.contentWindow.postMessage({
                                        type: 'form-sketch',
                                        event: 'init-iframe',
                                        data: {
                                            repeatedIndex,
                                            objectId,
                                            formIndex,
                                            formSketchData,
                                            formSketchSettings: formitize.api.form.objects.formCanvas.getFormSketchSettings(formIndex, objectId, repeatedIndex)
                                        }
                                    }, "*");
                                }
                            });

                        });
                    }
                ).catch( (ex) => {
                    alert("Failed to load form sketch data");
                    throw ex;
                });
            }

            return <>
                {profile.flagFormSketch && <GreenButton onClick={onClick}>Draw</GreenButton>}
            </>
        }

        function ComponentWrapper(props) {
            return <Spa as={React.Fragment} companyData={props.companyData ?? {}}>
                <Button {...props} />
            </Spa>
        }

        root.render(React.createElement(ComponentWrapper, {
            companyData,
            repeatedIndex,
            objectId,
            formIndex
        }));
    });    
}

window.addEventListener(
    "message", (ev) => {
        const d = ev.data;

        if(d.type !== 'form-sketch') return;

        if(d.event) {
            switch(d.event) {
                case 'init-iframe':
                    initiateFormSketchIFrame(d.data, ev.source);
                    break;
                case 'init':
                    initiateFormSketch();
                break;

                case 'init-annotation-iframe':
                   initiateAnnotationIFrame(d.data, ev.source);
                break;
                case 'init-annotation':
                    initiateAnnotation(d.data);
                break;
            }
        }
    }
);


//Create an iFrame if we are a top-level.
if(!isInIframe()) {
    mount_iFrame();
}

initiateFormSketch();

export default {};